﻿import LfDataService from '../../../Services/LfDataService';

import {
    pageHasErroredAction,
    pageErrorAction
} from '../../../State/actions';


const fetchAchievements = (data) => {
    return {
        type: 'ACHIEVEMENTS_FETCH',
        data: data
    }
}

const fetchNewAchievements = (data) => {
    return {
        type: 'NEW_ACHIEVEMENTS_FETCH',
        data: data
    }
}

const fetchAchievementsFailed = (failed) => {
    return {
        type: 'ACHIEVEMENTS_FETCH_FAILED',
        data: failed
    }
}

export const getAchievementsData = () => {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        let result;
        lfDataService.getAchievements()
            .then(data => {
             
                result = data;
                dispatch(fetchAchievements(result));
            })
            .catch(e => {
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
                dispatch(fetchAchievementsFailed(true));
            });
    }
}

export const getNewAchievementsData = () => {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        let result;
        lfDataService.getNewAchievements()
            .then(data => {

                result = data;
                dispatch(fetchNewAchievements(result));
            })
            .catch(e => {
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
                dispatch(fetchAchievementsFailed(true));
            });
    }
}

export const viewedAchievements = () => {
    const lfDataService = new LfDataService();

    return (dispatch) => {
        lfDataService.submitViewedAchievements()

            .then(result => {
                if (result.success) {
                    return;
                } else {
                    dispatch(pageErrorAction(e));
                    dispatch(pageHasErroredAction(true));
                }
            })
            .catch(e => {
                dispatch(pageErrorAction(e));
                dispatch(pageHasErroredAction(true));
            });
    }
}